// 订单
const vipOperation = [
  {
    path: "vipOrder",
    meta: {
      web_title: "转赠订单",
      key: "",
      word: "",
      requiresAuth: true,
      login: false,
      //
      isShow: true,
      title: "转赠订单",
      bgColor: "",
      textColor: "",
      rightText: "",
      rightHref: "",
    },
    component: () =>
      import(
        /* webpackChunkName: "userOrder" */ "../views/options/vipOrder/index.vue"
      ),
  },
  {
    path: "userOrderInfo",
    name: "userOrderInfo",
    meta: {
      web_title: "订单详情",
      key: "",
      word: "",
      requiresAuth: true,
      login: false,
      //
      isShow: true,
      title: "订单详情",
      bgColor: "",
      textColor: "",
      rightText: "",
      rightHref: "",
    },
    component: () =>
      import(
        /* webpackChunkName: "userOrderInfo" */ "../views/options/userOrder/userOrderInfo.vue"
      ),
  },
  {
    path: "userOrderInfos",
    name: "userOrderInfos",
    meta: {
      web_title: "订单详情",
      key: "",
      word: "",
      requiresAuth: true,
      login: false,
      //
      isShow: true,
      title: "订单详情",
      bgColor: "",
      textColor: "",
      rightText: "",
      rightHref: "",
    },
    component: () =>
      import(
        /* webpackChunkName: "userOrderInfo" */ "../views/options/userOrder/userOrderInfos.vue"
      ),
  },
  {
    path: "refundVerify",
    name: "refundVerify",
    meta: {
      web_title: "订单退款",
      key: "",
      word: "",
      requiresAuth: true,
      login: false,
      //
      isShow: true,
      title: "订单退款",
      bgColor: "",
      textColor: "",
      rightText: "",
      rightHref: "",
    },
    component: () =>
      import(
        /* webpackChunkName: "refundVerify" */ "../views/options/userOrder/refundVerify.vue"
      ),
  },
];

export default vipOperation;
